import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { SelectionGenericService } from '../../services/selection-generic.service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';

@Component({
    selector: 'app-popups',
    templateUrl: './popups.component.html',
    styleUrls: ['./popups.component.scss'],
    standalone: false
})
export class PopupsComponent implements OnInit {

  public companyNode: any;

  constructor(
    public dialogRef: MatDialogRef<PopupsComponent>,
    public sharedService: SharedService, 
    private companyTreeService: CompanyTreeViewService,
    public selectionService: SelectionGenericService,
    public dialog: MatDialog, 
    private employeeService: EmployeeService) {

  }

  ngOnInit(): any {

  }

  public Accept(): any {
    switch (this.sharedService.selectedSelectionTabId) {
      case 1:
        const companyId = this.companyTreeService.selectedCompanyId;
        if (companyId > 0 && this.selectionService.employeeResultModal.EmpresaID !== companyId) {
          this.OpenConfirmDialogForTraspasar(companyId);
        } else {
          this.sharedService.ShowSnackBar('Por favor seleccione una empresa', 'Okay', 2000);
        }
        break;

      case 2:
        break;

      default:
        break;
    }

  }

  public Close(): void {
    this.dialogRef.close();
  }

  private OpenConfirmDialogForTraspasar(companyId): void {
    const message = `¿Traspasar todos los trabajadores de la lista a la empresa?`;
    const dialogData = new ConfirmDialogModel('Confirmar acción', message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.selectionService.isLoading = true;
        // Used employeeResultModal in case any filter modifications were made after the result was generated
        this.employeeService.TraspasarEmployee(companyId, this.selectionService.employeeResultModal).subscribe(res => {
          if (res.code === 0) {
            // Refresh Table - ALL IN THE RESULT US TRASNFERED
            this.selectionService.dataSource.data = [];
            this.sharedService.ShowSnackBar('Traspaso de trabajador exitosa', 'Okay', 2000);
          } else {
            this.sharedService.ShowSnackBar('No puedo traspasar al trabajador', 'Okay', 2000);
          }
          this.selectionService.isLoading = false;

        }, err => {
          this.selectionService.isLoading = false;
          console.error(err);
        });
      }
      this.dialogRef.close();
    });
  }

}
